import { render } from "./DashboardOrdersTab.vue?vue&type=template&id=ebb979b8&scoped=true"
import script from "./DashboardOrdersTab.vue?vue&type=script&lang=js"
export * from "./DashboardOrdersTab.vue?vue&type=script&lang=js"

import "./DashboardOrdersTab.vue?vue&type=style&index=0&id=ebb979b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb979b8"]])

export default __exports__